import React from "react";
import { Link } from "react-router-dom";
import CtaThreeShapeImg1 from "../../assets/images/shapes/cta-three-shape-img-1.png";
import CtaThreeShapeImg2 from "../../assets/images/shapes/cta-three-shape-img-2.png";

function CtaThree() {
  return (
    <div>
      <section className="cta-three">
        <div className="container">
          <div className="cta-three-title-box">
            <div className="cta-three-shape-1">
              <div className="animation_image_zoom">
                <div className="cta-three-shape-1-img">
                  <img src={CtaThreeShapeImg1} alt="cta-three-shape-img-1" />
                </div>
              </div>
            </div>
            <div className="cta-three-shape-2">
              <div className="animation_image_zoom">
                <div className="cta-three-shape-2-img">
                  <img src={CtaThreeShapeImg2} alt="cta-three-shape-img-2" />
                </div>
              </div>
            </div>
            <div
              className="section-three-title text-center wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="100ms"
            >
              <div className="section-three-title-title">
                <h2>
                  Ready to Boost your <br /> Digital product marketing ?
                </h2>
              </div>
            </div>
            <div
              className="section-three-details text-center wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="200ms"
            >
              <p>Approach focuses on capturing the essential</p>
            </div>
            <div
              className="section-three-btn text-center wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="300ms"
            >
              <Link to="/contact" className="main-btn-three thm-btn">
                Get Started
                <i className="icon-right-arrow" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CtaThree;
